module.exports = __webpack_public_path__ + "img/logo-cropped.d27c3ec6.jpg";